export const HealthRoutes = [
    {
        path: '/health-check',
        name: 'health-check-page',
        component: () => import('./HealthCheckView.vue'),
    },
];
